var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_vm._l((_vm.contents),function(content,index){return [_c('v-col',{key:index,attrs:{"cols":"12","sm":"4","lg":"3"}},[_c('video-modal',{attrs:{"content":content}}),_c('p',{staticClass:"text-primary mb-0 mt-1"},[_vm._v(_vm._s(content.title))])],1)]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }